const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://api.example.com'

class ApiClient {
  constructor(baseURL = API_BASE_URL) {
    this.baseURL = baseURL
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`

    // Get JWT from localStorage for authentication
    const jwt = localStorage.getItem('stytch_session_jwt')

    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(jwt && { 'Authorization': `Bearer ${jwt}` }),
        ...options.headers,
      },
      ...options,
    }

    try {
      const response = await fetch(url, config)

      if (!response.ok) {
        // Try to get error message from response body
        let errorMessage = `HTTP error! status: ${response.status}`
        try {
          const errorData = await response.json()
          if (errorData.message || errorData.error) {
            errorMessage = errorData.message || errorData.error
          }
        } catch (e) {
          // If response is not JSON, use status text
          errorMessage = response.statusText || errorMessage
        }
        throw new Error(errorMessage)
      }

      // Check if response has content
      const contentType = response.headers.get('content-type')
      const contentLength = response.headers.get('content-length')

      // Handle empty responses (204 No Content or empty body)
      if (response.status === 204 || contentLength === '0') {
        return null
      }

      // Only parse JSON if content-type is JSON
      if (contentType && contentType.includes('application/json')) {
        const text = await response.text()
        // Handle empty text response
        if (!text || text.trim() === '') {
          return null
        }
        return JSON.parse(text)
      }

      // For non-JSON responses, return as text
      const text = await response.text()
      return text || null
    } catch (error) {
      console.error('API request failed:', error)
      throw error
    }
  }

  get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' })
  }

  post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'POST',
      body: JSON.stringify(data),
    })
  }

  put(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: 'PUT',
      body: JSON.stringify(data),
    })
  }

  delete(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'DELETE' })
  }
}

export default new ApiClient()
